import routes from 'netxcore@netx/core-app/routes';
import {appRouter} from '@netx/core-next/instance/router';
import {assetProjectEnabled} from '@netx/core-asset-project/enablers';

// Deferred module routes
Object.assign(routes, {
	'document(/*anything)'() {
		dispatcher.trigger('netx:load:module:pdfViewer', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:uploadAssetRequestManager
	 */
	'assets/requests(/*anything)'() {
		dispatcher.trigger('netx:load:module:uploadAssetRequestManager', {
			loadUrl: true,
		});
	},
	/**
	 * @route
	 * @fires netx:load:module:audioeditor
	 */
	'audioeditor(/*anything)'() {
		dispatcher.trigger('netx:load:module:audioeditor', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:dataset
	 */
	'dataset(/*anything)'() {
		dispatcher.trigger('netx:load:module:dataset', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:imageeditor
	 */
	'imageeditor(/*anything)'() {
		dispatcher.trigger('netx:load:module:imageeditor', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:stat
	 */
	'stat(/*anything)'() {
		dispatcher.trigger('netx:load:module:stat', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system/groups(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:system:groups', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:system', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:videoeditor
	 */
	'videoeditor(/*anything)'() {
		dispatcher.trigger('netx:load:module:videoeditor', {loadUrl: true});
	},
});

// TODO: this check has to be failing given we do not have prefs yet
// we need to ensure prefs are loaded post auth before any other modules are called upon
if (assetProjectEnabled()) {
	/**
	 * @route
	 * @fires netx:load:module:project
	 */
	routes['projects(/*anything)'] = () => {
		dispatcher.trigger('netx:load:module:project', {loadUrl: true});
	};
}

export default routes;
